const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec));

const searchShippingDayElement = async () => {
  for (let i = 0; i < 50; i++) {
    const shippingDayElement = document.querySelector('.cacao-delivery');
    if (shippingDayElement) {
      return shippingDayElement;
    }
    await sleep(100);
  }
  return null;
};

searchShippingDayElement().then(shippingDayElement => {
  if (shippingDayElement) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const isGiftEnabledItemInCart = cart.items.some(item =>
          item.properties &&
          'ギフト購入' in item.properties &&
          item.properties['ギフト購入'] === '有効'
        );

        if (isGiftEnabledItemInCart) {
          // 要素を無効化する
          shippingDayElement.style.display = 'none';
          //配送日時指定を無効にする
          const dateInput = document.getElementById('cacao-delivery-date');
          const timeInput = document.getElementById('cacao-delivery-time');
          if (dateInput) {
            dateInput.setAttribute('disabled', 'disabled');
          }
          if (timeInput) {
            timeInput.setAttribute('disabled', 'disabled');
          }
        }
      })
      .catch(error => {
        console.log(`cart.js 読み込み失敗 ${error.message}`);
      });
  }
});
